import _ from "lodash";

export const filterResults = (data, searchProperties, filter) => {
  let filteredData = data;

  if (filter && !_.isEmpty(searchProperties)) {
    filteredData = data.filter(item =>
      searchProperties.some(property => {
        let value = _.get(item, property.keyName);

        if (property.formatRowData) {
          value = property.formatRowData(value, item);
        }

        return typeof value === "string" && value.toLowerCase().includes(filter.toLowerCase());
      })
    );
  }

  return filteredData;
};

export const sortResults = (data, searchProperties, sort) => {
  let sortedData = data;

  if (!_.isEmpty(sort)) {
    const sortValue = item => {
      const property = searchProperties.find(searchProperty => searchProperty.keyName === sort.keyName);
      if (!property) {
        return false;
      }

      let value = _.get(item, property.keyName);

      if (property.formatRowData) {
        value = property.formatRowData(value, item);
      }

      return value;
    };

    sortedData = _.orderBy(sortedData, sortValue, sort.direction);
  }

  return sortedData;
};

export const paginateResults = (data, firstElement, lastElement) => data.slice(firstElement, lastElement);

export const toggleListRow = (id, openedRows, callback) => {
  const updatedOpenedRows = [...openedRows];
  const index = updatedOpenedRows.indexOf(id);

  if (index !== -1) {
    updatedOpenedRows.splice(index, 1);
  } else {
    updatedOpenedRows.push(id);
  }

  callback(updatedOpenedRows);
};



// WEBPACK FOOTER //
// ./src/helpers/listHelpers.js